/* ==========================================================================
   TNF colour reference 1.1.0                                    2026-09-17
   --------------------------------------------------------------------------
   ONE explicit ON / OFF appearance for every selectable tube colour.

   Reference for the UNLIT appearance and the colour groups: the supplied
   "The Neon Factory Colour Guide.pdf" (17 Sep 2026), read from the file
   itself - every OFF and ON swatch was sampled from the PDF's own vector
   artwork (columns 'off' / 'guideOn' / 'guideCore' below). It supersedes the
   17 Sep list: ICE BLUE is coloured when off (was white in 1.0.0).
   Groups in the guide:
     COLOURED SILICONE (coloured when OFF): Blue, Golden Yellow, Green,
       Ice Blue, Lemon Yellow, Light Baby Pink, Mint Green, Mint Teal Green,
       Light Red, Orange, Pink, Purple, Red, Yellow
     WHITE SILICONE (white when OFF): Baby Pink, Cool Ice Blue, Deep Green,
       Lilac, Midnight Blue, Hot Pink, Sunbeam Glow, Tangerine Glow
     CLASSIC WHITES: Cool White, Warm White - shown lit with the white / cream
       appearance the guide draws (litSource 'guide')

   LIT colour ('hex'): the store's neon_colors metaobject registry (what the
   live creator uses) for every colour except the two classic whites. The
   guide's own lit swatches are kept beside it ('guideOn', the tube edge, and
   'guideCore', its bright centre) as a screen reference, not a measurement:
   the guide itself says previews are indicative.

   NOT established by the guide, and not invented here: Blush Pink (in the
   registry, absent from the guide) and the unlit appearance of RGB / RGBW.
   ON/OFF is a preview control only. Nothing here touches price, size,
   options or the record of the order.
   ========================================================================== */
(function (root) {
  'use strict';

  function C(name, hex, litSource, offGroup, off, guideOn, guideCore) {
    return { name: name, hex: hex, litSource: litSource, offGroup: offGroup, off: off,
             offRef: 'colour guide PDF (17 Sep 2026), sampled', guideOn: guideOn, guideCore: guideCore, conflict: null };
  }

  var COLOURS = [
    /* ---- COLOURED SILICONE - coloured when off ------------------------- */
    C('Blue', '#262ac2', 'registry', 'coloured', '#739afe', '#417aff', '#a0bcff'),
    C('Golden Yellow', '#ecaa3e', 'registry', 'coloured', '#f7d93a', '#e6d72d', '#f3eb96'),
    C('Green', '#0fc340', 'registry', 'coloured', '#7ad26a', '#76c968', '#bae4b4'),
    C('Ice Blue', '#01c1bd', 'registry', 'coloured', '#a2dedc', '#a7e5e4', '#d3f2f1'),
    C('Lemon Yellow', '#e0d700', 'registry', 'coloured', '#eae546', '#e7e342', '#f3f1a0'),
    C('Light Baby Pink', '#ed687f', 'registry', 'coloured', '#f1bfd9', '#f1cddf', '#f8e6ef'),
    C('Mint Green', '#4fd04b', 'registry', 'coloured', '#a4dc55', '#63d578', '#b1eabb'),
    C('Mint Teal Green', '#07cb75', 'registry', 'coloured', '#64ddd9', '#a0e3db', '#d0f1ed'),
    C('Light Red', '#fa0733', 'registry', 'coloured', '#fa9791', '#ef9999', '#f7cccc'),
    C('Orange', '#f55305', 'registry', 'coloured', '#fbb668', '#f4b644', '#f9dba1'),
    C('Pink', '#ed27fc', 'registry', 'coloured', '#f4b2ca', '#efadce', '#f7d6e7'),
    C('Purple', '#840ef7', 'registry', 'coloured', '#c172cc', '#cb87d5', '#e5c3ea'),
    C('Red', '#f50521', 'registry', 'coloured', '#ff8d84', '#ff243c', '#ff929e'),
    C('Yellow', '#d9d701', 'registry', 'coloured', '#e9ed08', '#dde738', '#eef39c'),
    /* ---- WHITE SILICONE - white when off -------------------------------- */
    C('Baby Pink', '#fa42de', 'registry', 'white', '#f6f6f4', '#f3b5cc', '#f9dae5'),
    C('Cool Ice Blue', '#03abc1', 'registry', 'white', '#f6f6f4', '#bee8ef', '#dff4f7'),
    C('Deep Green', '#1dc868', 'registry', 'white', '#f6f6f4', '#6daf6b', '#b6d7b5'),
    C('Lilac', '#b024ee', 'registry', 'white', '#f6f6f4', '#d7b6e1', '#ebdbf0'),
    C('Midnight Blue', '#2108ee', 'registry', 'white', '#f6f6f4', '#8b96df', '#c5caef'),
    C('Hot Pink', '#fa0e93', 'registry', 'white', '#f6f6f4', '#f151a7', '#f8a8d3'),
    C('Sunbeam Glow', '#e06a02', 'registry', 'white', '#f6f6f4', '#e3e4ba', '#f1f1dd'),
    C('Tangerine Glow', '#efac3c', 'registry', 'white', '#f6f6f4', '#f2bd57', '#f9deab'),
    /* ---- CLASSIC WHITES - lit appearance from the guide ----------------- */
    C('Cool White', '#e9eeff', 'guide', 'white', '#f6f6f4', '#e9eeff', '#f4f7ff'),
    C('Warm White', '#ebe6d1', 'guide', 'white', '#f4f0df', '#ebe6d1', '#f5f3e8')
  ];
  /* in the store registry but NOT in the guide: kept selectable, reference missing */
  COLOURS.push({ name: 'Blush Pink', hex: '#ff00ff', litSource: 'registry', offGroup: null, off: null,
                 offRef: 'registry only - not in the colour guide; unlit appearance NOT ESTABLISHED (shown neutral when off)', guideOn: null, guideCore: null,
                 conflict: 'not in the colour guide of 17 Sep 2026' });

  var RGB_MODES = {
    rgb:  { name: 'Premium RGB',  off: null, offRef: 'missing - no unlit reference in the guide or the registry' },
    rgbw: { name: 'Premium RGBW', off: null, offRef: 'missing - no unlit reference in the guide or the registry' }
  };

  var BY = {}; COLOURS.forEach(function (c) { BY[c.name.toLowerCase()] = c; });
  function byName(n) { return BY[String(n || '').toLowerCase()] || null; }
  /* Merge the live registry (name -> lit hex) with this reference. The lit
     hex is the registry's unless this file names the guide as its source.
     Anything in the registry with no entry here is reported, never guessed. */
  function merge(registry) {
    var out = [], missing = [];
    (registry || []).forEach(function (r) {
      var m = byName(r.name);
      if (!m) { missing.push(r.name); out.push({ name: r.name, hex: r.hex, off: null, offGroup: null, offRef: 'missing - not in the colour reference', litSource: 'registry' }); }
      else out.push({ name: r.name, hex: m.litSource === 'guide' ? m.hex : (r.hex || m.hex), off: m.off, offGroup: m.offGroup, offRef: m.offRef,
                      litSource: m.litSource, guideOn: m.guideOn, guideCore: m.guideCore, conflict: m.conflict,
                      litDiffers: (m.litSource !== 'guide' && r.hex && r.hex.toLowerCase() !== m.hex.toLowerCase()) ? m.hex : null });
    });
    return { list: out.length ? out : COLOURS.slice(), missing: missing };
  }

  var API = { version: '1.1.0', list: COLOURS, byName: byName, merge: merge, RGB_MODES: RGB_MODES,
              source: { lit: 'neon_colors metaobjects (classic whites: colour guide PDF)', off: 'The Neon Factory Colour Guide.pdf, 17 Sep 2026, sampled from the vector artwork' } };
  root.TNF_COLOURS = API;
  if (typeof module !== 'undefined' && module.exports) module.exports = API;
})(typeof window !== 'undefined' ? window : globalThis);
